import { API } from 'aws-amplify';

//const API_NAME = 'admin-api';
const API_NAME_V2 = 'admin-api-v2';

export const getAllTenants = async () => {
  return API.get(API_NAME_V2, '/tenants', {});
};

export const createTenant = async (data) => {
  return API.post(API_NAME_V2, '/registration', { body: data });
};

export const getTenant = async (tenantId) => {
  return API.get(API_NAME_V2, `/tenant/${tenantId}`, {});
};

export const updateTenant = async (tenantId, data) => {
  return API.put(API_NAME_V2, `/tenant/${tenantId}`, { body: data });
};

export const deactivateTenant = async (tenantId) => {
  return API.del(API_NAME_V2, `/tenant/${tenantId}`, {});
};

export const activateTenant = async (tenantId) => {
  return API.put(API_NAME_V2, `/tenant/activation/${tenantId}`, {});
};

export const getTenantBilling = async (tenantId) => {
  return API.get(API_NAME_V2, `/tenant/${tenantId}/billing`, {});
};

export const extendTrial = async (tenantId, data) => {
  return API.put(API_NAME_V2, `/tenant/${tenantId}/extend-trial`, { body: data });
};

export const getTenantUsers = async (tenantId) => {
  return API.get(API_NAME_V2, `/tenant/${tenantId}/users`, {});
};

export const createTenantUser = async (data) => {
  return API.post(API_NAME_V2, '/user', { body: data });
};

export const disableTenantUser = async (username, tenantId) => {
  return API.put(API_NAME_V2, `/tenant/${tenantId}/users/${username}/disable`, {});
};

export const enableTenantUser = async (username, tenantId) => {
  return API.put(API_NAME_V2, `/tenant/${tenantId}/users/${username}/enable`, {});
};

export const updateTenantUserRole = async (username, tenantId, role) => {
  return API.put(API_NAME_V2, `/tenant/${tenantId}/users/${username}`, {
    body: { userRole: role },
  });
};

export const deleteTenantUser = async (username, tenantId) => {
  return API.del(API_NAME_V2, `/tenant/${tenantId}/users/${username}`, {});
};

export const updateTenantFeatures = async (tenantId, data) => {
  return API.put(API_NAME_V2, `/tenant/${tenantId}/features`, { body: data });
};

export const archiveTenant = async (tenantId) => {
  return API.post(API_NAME_V2, `/tenant/${tenantId}/archive`, {});
};

export const restoreTenant = async (tenantId) => {
  return API.post(API_NAME_V2, `/tenant/${tenantId}/restore`, {});
};

export const getArchiveStatus = async (tenantId) => {
  return API.get(API_NAME_V2, `/tenant/${tenantId}/archive/status`, {});
};
